import { AxiosError, AxiosResponse } from "axios";
import { http } from "src/core/services/http.services";
import { messagesError } from "src/core/services/messages.services";
import { DataResponse } from "src/shared/interface/data-response";

export const httpReq = async (path: string) => {
  const getAll = async <T = any>(): Promise<DataResponse<T[]>> => {
    return http
      .Client(http.Headers.headers)
      .get(`${path}/all`)
      .then((response: AxiosResponse) => {
        return response.data;
      })
      .catch((error: AxiosError) => {
        messagesError(error);
        throw error;
      });
  };

  const getId = async <T = any>(id: string): Promise<DataResponse<T>> => {
    return http
      .Client(http.Headers.headers)
      .get(`${path}/${id}`)
      .then((response: AxiosResponse) => {
        return response.data;
      })
      .catch((error: AxiosError) => {
        messagesError(error);
        throw error;
      });
  };

  const getPaginate = async <T = any>(
    limit: string = '10',
    lastEvaluatedKey: string | null = null
  ): Promise<DataResponse<T[]>> => {
    const params = {
      lastEvaluatedKey,
      limit,
    };
    return http
      .Client(http.Headers.headers)
      .get(`${path}`, { params })
      .then((response: AxiosResponse) => {
        return response.data;
      })
      .catch((error: AxiosError) => {
        messagesError(error);
        throw error;
      });
  };

  const getFilterPaginate = async <T = any>(
    filter: string,
    valueQuery: any,
    limit: string = '10',
    lastEvaluatedKey: string | null = null,
    sortOrder: "ASC" | "DESC" = "ASC",
    sortBy: string = "name"
  ): Promise<DataResponse<T>> => {
    const params = {
      filter,
      valueQuery,
      lastEvaluatedKey,
      limit,
      sortOrder,
      sortBy,
    };
    return http
      .Client(http.Headers.headers)
      .get(`${path}`, { params })
      .then((response: AxiosResponse) => {
        return response.data;
      })
      .catch((error: AxiosError) => {
        messagesError(error);
        throw error;
      });
  };

  const create = async <T = any>(payload: any): Promise<DataResponse<T>> => {
    return http
      .Client(http.Headers.headers)
      .post(`${path}`, payload)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        messagesError(error);
        throw error;
      });
  };

  const uploadFile = async <T = any>(file: any, pathFile: string): Promise<DataResponse<T>> => {
    const payload = {filename: file.name};
    console.log(payload);
    return http
      .Client(http.Headers.headers)
      .put(`${path}/upload/${pathFile}`, payload)
      .then(async (response) => {
        return await uploadFileSignedUrl(response.data.data.signedUrl, file).then((res) => {
          console.log(res);
          return response.data.data
        }).catch((error) => {
          messagesError(error);
          throw error;
        });
      })
      .catch((error) => {
        messagesError(error);
        throw error;
      });
  };

  const uploadFileSignedUrl = async <T = any>(url: string, file: any): Promise<DataResponse<T>> => {
    const formData = new FormData();
    formData.append("file", file);
    return http
      .Client({headers: {
        'Content-Type': file.type,
      },})
      .put(`${url}`, formData)
      .then((response) => {
        return response.data.data;
      })
      .catch((error) => {
        messagesError(error);
        throw error;
      });
  };

  const update = async <T = any>(
    id: string,
    payload: any
  ): Promise<DataResponse<T>> => {
    return http
      .Client(http.Headers.headers)
      .put(`${path}/${id}`, payload)
      .then((response) => {
        return response.data.data;
      })
      .catch((error) => {
        messagesError(error);
        throw error;
      });
  };

  const remove = async <T = any>(id: string): Promise<DataResponse<T>> => {
    return http
      .Client(http.Headers.headers)
      .delete(`${path}/${id}`)
      .then((response) => {
        return response.data.data;
      })
      .catch((error) => {
        messagesError(error);
        throw error;
      });
  };

  return {
    getAll,
    getId,
    getPaginate,
    getFilterPaginate,
    create,
    update,
    remove,
    uploadFile
  };
};
